
export enum PrintModalStageState {
  // 0: Modal is not visible
  NOT_VISIBLE = 0,
  // 1: Modal asks user to confirm awarding badges prior to printing
  CONFIRM_AWARDING = 1,
  // 2: Modal asks users whether to print in color or monochrome
  CONFIRM_PRINT_COLOR = 2,
}

export default PrintModalStageState;